module.exports = __webpack_public_path__ + "img/chinese-dragon-tattoos-for-men.jpg";